require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-free-wordpress-plugins.json") })
        }
      }, "path---tapd-in-free-wordpress-plugins");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-free-wordpress-plugins!./.cache/json/tapd-in-free-wordpress-plugins.json
// module id = 831
// module chunks = 231608221292675